module.exports = __webpack_public_path__ + "static/media/lumbering1.41e708ab.jpg";